export function toLocalYmd(date) {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function parseLocalYmd(ymd) {
    if (!ymd || typeof ymd !== "string") return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd.trim());
    if (!m) return null;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    const date = new Date(y, mo - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) {
        return null;
    }
    return date;
}

export function holidayYmdSet(holidays = []) {
    const set = new Set();
    for (const h of holidays) {
        const raw = h?.date ?? h;
        const ymd = typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)
            ? raw.slice(0, 10)
            : toLocalYmd(raw);
        if (ymd) set.add(ymd);
    }
    return set;
}

export function isBusinessDay(date, holidaySet = new Set()) {
    if (!date || Number.isNaN(date.getTime())) return false;
    const dow = date.getDay();
    if (dow === 0 || dow === 6) return false;
    const ymd = toLocalYmd(date);
    if (holidaySet.has(ymd)) return false;
    return true;
}

export function snapToBusinessDay(date, holidaySet = new Set()) {
    const cur = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    while (!isBusinessDay(cur, holidaySet)) {
        cur.setDate(cur.getDate() + 1);
    }
    return cur;
}

/** Espelha calculateDeadline do backend (services.js). */
export function addBusinessDays(start, days, holidaySet = new Set()) {
    let remaining = Number(days) || 0;
    const calculatedDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (remaining > 0) {
        calculatedDate.setDate(calculatedDate.getDate() + 1);
        if (isBusinessDay(calculatedDate, holidaySet)) {
            remaining--;
        }
    }
    return calculatedDate;
}

export function countBusinessDays(start, end, holidaySet = new Set()) {
    const a = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const b = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    if (toLocalYmd(b) < toLocalYmd(a)) return -1;
    let count = 0;
    const cur = new Date(a);
    while (toLocalYmd(cur) < toLocalYmd(b)) {
        cur.setDate(cur.getDate() + 1);
        if (isBusinessDay(cur, holidaySet)) count++;
    }
    return count;
}
